export const Nav = () => {
  const handleScroll = (e, id) => {
    e.preventDefault();

    const target = document.getElementById(id);
    if (!target) return;

    // ヘッダー要素をその場で取得
    const header = document.querySelector("header");
    // ヘッダーが存在すればその高さを、なければ 0 を代入
    const headerHeight = header ? header.offsetHeight : 0;

    const targetPosition = target.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: targetPosition - headerHeight, // 動的な高さを引く
      behavior: "smooth",
    });
  };

  return (
    <>
      <header>
        <h1>雷と雷保護技術セミナー</h1>
        <nav>
          <ul>
            <li>
              <a href="hokuriku" onClick={(e) => handleScroll(e, "hokuriku")}>
                北陸開催
                <br />
                10月9日<span>&#12942;</span>
              </a>
            </li>
            <li>
              {/* hrefをid名に合わせて呼び出し */}
              <a href="#osaka" onClick={(e) => handleScroll(e, "osaka")}>
                大阪開催
                <br />
                5月19日<span>&#12939;</span>
              </a>
            </li>
            <li>
              <a href="kyusyu" onClick={(e) => handleScroll(e, "kyusyu")}>
                九州開催
                <br />
                6月12日<span>&#12942;</span>
              </a>
            </li>
            <li>
              <a href="tokyo" onClick={(e) => handleScroll(e, "tokyo")}>
                東京開催
                <br />
                7月24日<span>&#12942;</span>
              </a>
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
};
